export default "__VITE_ASSET__BF2hz$0Z__"